module.exports = __webpack_public_path__ + "static/media/nav-icon-contacts.0e0f3885.svg";